"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DueDateStatus = exports.DueDateStatusIterable = exports.StatusEnum = exports.StatusEnumIterable = void 0;
exports.StatusEnumIterable = [
    'notStarted',
    'upcoming',
    'dueSoon',
    'overdue',
    'expired',
    'completed',
    'waived',
];
exports.StatusEnum = {
    NotStarted: 'notStarted',
    Upcomint: 'upcoming',
    DueSoon: 'dueSoon',
    Overdue: 'overdue',
    Expired: 'expired',
    Completed: 'completed',
    Waived: 'waived',
};
exports.DueDateStatusIterable = [
    'upcoming',
    'dueSoon',
    'overdue',
    'expired',
];
exports.DueDateStatus = {
    Upcoming: 'upcoming',
    DueSoon: 'dueSoon',
    Overdue: 'overdue',
    Expired: 'expired',
};
//# sourceMappingURL=v2DEPRECATED.js.map